import styled from 'styled-components';

interface PostWrapperProps {
  first?: boolean;
}

export const Wrapper = styled.div<PostWrapperProps>`
  margin: 0 auto;
  margin-bottom: 1.5rem;
  max-width: 1200px;

  display: inline-flex;
  flex-direction: column;
  font-family: Montserrat;

  font-weight: bold;

  .list-cardblog {
    .list-container {
      width: 336px;

      min-height: 500px;

      height: auto;
      background: #ffffff;
      box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.15);
      border-radius: 15px;
      margin-top: 3rem;
      a {
        text-decoration: none;
      }

      .image {
        object-fit: cover;
        border-radius: 17.8193px 17.8193px 0px 0px;
        width: 100%;
      }

      .list-card-items {
        display: flex;
        flex-direction: column;
        padding: 1.5rem;

        .category {
          font-size: 11.2776px;
          margin-top: -10px;
          text-transform: uppercase;
          color: #2253f5;
        }

        .title {
          margin-top: 17px;
          max-width: 100%;
          font-size: 18px;
          line-height: 23px;
          color: #333333;
        }

        .excerpt {
          margin-top: 10px;
          font-family: Montserrat;
          font-weight: normal;

          font-size: 13px;
          color: #333333;
        }
      }
    }

    /* a:not(.title):not(.img) {
    width: 178px;
    height: 40px;
    border: 1px solid #2253f5;
    color: #2253f5;
    background: none;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;

    font-family: Montserrat;
    font-weight: bold;
    font-size: 16px;

    margin-top: 30px;
  } */

    @media (max-width: 768px) {
      max-width: 768px;
      margin: 0px auto;
      margin-bottom: 2rem;

      .list-cardblog {
        .list-container {
          width: 300px;
          height: auto;
        }
      }

      .image {
        height: 200px;
      }
    }
  }
`;

export const FirstWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4rem;
  margin-right: 14.3rem;
  font-family: Montserrat;

  .list-items {
    width: 35%;
    margin-bottom: 7rem;
    display: flex;
    align-items: right;
    flex-direction: column;

    .category {
      margin-bottom: 17px;
      margin-left: -2px;
      font-size: 12px;
      text-transform: uppercase;
      color: #2253f5;
      font-weight: bold;
    }
    .title {
      text-decoration: none;
      font-weight: bold;
      font-size: 27.5831px;
      margin-left: -4px;
      line-height: 33px;
      color: #333333;
    }
    .excerpt {
      font-size: 16.5499px;
      font-weight: 300;
      line-height: 22px;
    }
  }

  .image {
    margin-right: 47px;
    margin-bottom: 30px;
    img {
      border-radius: 17.8px;
    }
  }

  @media (max-width: 768px) {
    margin: 0 auto;
    flex-direction: column;
    justify-content: center;

    .list-items {
      width: 100%;
      margin-bottom: 2rem;
      .title {
        font-size: 25px;
      }

      .excerpt {
        font-size: 15.36px;
      }
    }
    .image {
      margin-top: 3rem;

      margin-right: 0px;
      width: 300px;
      height: 200px;
      border-radius: 15px;
    }
  }
`;
